export default {
  name: 'SubsiteAccordionItemBlock',
  props: {},
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
    keydown(event) {
      if (
        event !== null &&
        event.type === 'keydown' &&
        (event.ctrlKey || event.metaKey) &&
        event.keyCode === 70
      ) {
        this.open();
      }
    },
    open() {
      if (!this.isOpen) this.isOpen = true;
    }
  },
  created() {
    window.addEventListener('keydown', this.keydown);
  },
  destroyed() {
    window.removeEventListener('keydown', this.keydown);
  }
};
